import styled from "@emotion/styled";

export const AuthFormWrapper = styled.div`
  width: 340px;
  height: 380px;
  background: #fff;
  padding: 20px;
  position: absolute;
  top: 50px;
  left: 870px;
  text-align: center;
  background-color: transparent;
  font-weight: 500;

  h1 {
    font-weight: bold;
    text-align: left;
  }

  p {
    text-align: left;
  }

  p a {
    color: #d8476b;
  }

  input {
    color: #ccc;
    font-size: 1.125rem;
    height: 40px;
    /* letter-spacing: 1px; */
  }

  label {
    display: block;
    font-size: 1.25rem;
    font-weight: bold;
    text-align: left;
    margin-top: 0.625rem;
  }

  @media (max-width: 1024px) {
    left: 0;
    top: 22.5vh;

    .btn {
      margin-bottom: 2rem;
    }
  }

  @media (max-width: 858px) {
    left: 0;
    top: 22.5vh;

    .bg-image {
      display: none;
    }
    .sign-up-form {
      float: left;
      margin-left: -650px;
    }
    .icon {
      margin-left: -7px;
    }
    .icon img {
      width: 70px;
      height: auto;
    }
  }

  @media (max-width: 440px) {
    left: 0;
    top: 22.5vh;
    width: 100%;

    .logo {
      display: none;
    }
    .sign-up-form {
      margin-left: -857px;
      width: 80%;
    }
    .sign-up-form h1 {
      font-size: 30px;
    }
  }
`;

export const Error = styled.div`
  background-color: #ff464680;
  border: 1px solid #ff4646;
  padding: 0.625rem;
`;
